import React from 'react';
import { useTranslation } from 'react-i18next';

/* Bočni panel sa alarmima vozila — pojavljuje se dok alarmi kruže po mapi.

   Redosled je po datumu isteka, prvo ono što ističe najpre (tako stiže iz
   procedure, ne sortira se ponovo ovde). Isteklo se boji crveno, ono što
   ističe u roku od nedelju dana narandžasto.

   Panel se ne montira kad nema nijedne stavke (uslov je u GPS.js), pa ovde
   nema praznog stanja — nema ni šta da se prikaže.

   Firma se ispisuje samo kad ih ima više — korisnik koji radi u jednoj firmi
   ne treba da čita isti naziv u svakom redu. */

const boja = (dana) => {
    if (dana < 0) return 'gps-alarm-isteklo';
    if (dana <= 7) return 'gps-alarm-uskoro';
    return '';
};

const PanelAlarmi = ({ alarmi = [], onZatvori, naVozilo }) => {
    const { t } = useTranslation();

    // Naziv firme se prikazuje tek kad ih ima više od jedne.
    const viseFirmi = new Set(alarmi.map(a => a.firma_id)).size > 1;

    const isteklo = alarmi.filter(a => a.dana_do < 0).length;

    return (
        <aside className="gps-panel gps-panel-alarmi">
            <div className="gps-panel-vrh">
                <div>
                    <div className="gps-panel-reg">{t('gps.alarmiVozila')}</div>
                    <div className="gps-panel-vrsta">
                        {alarmi.length} {t('gps.stavki')}
                        {isteklo > 0 && <span className="gps-alarm-isteklo"> · {isteklo} {t('gps.istekloBroj')}</span>}
                    </div>
                </div>
                <button
                    type="button"
                    className="gps-panel-x"
                    onClick={onZatvori}
                    aria-label={t('gps.ugasiAlarme')}
                    title={t('gps.ugasiAlarme')}
                >
                    <i className="pi pi-times" />
                </button>
            </div>

            <div className="gps-alarm-lista">
                {alarmi.map((a, i) => (
                    <button
                        key={`${a.id_vozilo}-${a.dokument}-${i}`}
                        type="button"
                        className={`gps-alarm-red ${boja(a.dana_do)}`}
                        /* Klik vodi na vozilo, ali samo ako je uopšte na GPS-u —
                           vozilo bez uređaja se prikazuje u spisku, a ne može na mapi. */
                        onClick={() => {
                            /* Povlačenje miša preko teksta završava se klikom na isti
                               element. Bez ove provere bi svako označavanje registracije
                               radi kopiranja odvelo mapu na to vozilo. Mousedown je već
                               poništio raniji izbor, pa nesažet izbor u ovom trenutku
                               znači da je korisnik upravo označavao tekst — ne klikao. */
                            const izbor = window.getSelection();
                            if (izbor && !izbor.isCollapsed) return;
                            if (a.mobilisis_id) naVozilo(a.mobilisis_id);
                        }}
                        disabled={!a.mobilisis_id}
                        title={a.mobilisis_id ? t('gps.prikaziNaMapi') : t('gps.nijeNaGpsu')}
                    >
                        <span className="gps-alarm-reg">{a.registracija}</span>
                        <span className="gps-alarm-dok">{a.dokument}</span>
                        <span className="gps-alarm-datum">
                            {/* Šestomesečni se obavlja u prozoru od ±15 dana oko roka, pa mu
                                stoje oba datuma; ostalima je jedan. Svaki datum je u svom
                                span-u da prelom raspona ide na crtici, a ne kroz datum. */}
                            {a.datum_od && <><span className="gps-alarm-dan">{a.datum_od}</span>{' – '}</>}
                            <span className="gps-alarm-dan">{a.datum}</span>
                            <em>
                                {a.dana_do < 0
                                    ? t('gps.istekloPre', { dana: Math.abs(a.dana_do) })
                                    : t('gps.istekZa', { dana: a.dana_do })}
                            </em>
                        </span>
                        {/* Napomena ide u svoj red preko cele sirine i nosi ikonicu —
                            treba da se cita kao ljudska beleska, a ne kao jos jedan
                            podatak iz baze. Duga napomena se secka, cela je u
                            title-u: red u dvokolonskom panelu ne sme da naraste. */}
                        {a.napomena && (
                            <span className="gps-alarm-napomena" title={a.napomena}>
                                <i className="pi pi-comment" />
                                <span>{a.napomena}</span>
                            </span>
                        )}
                        {viseFirmi && a.firma && <span className="gps-alarm-firma">{a.firma}</span>}
                    </button>
                ))}
            </div>
        </aside>
    );
};

export default PanelAlarmi;
